import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useAtom } from 'jotai';

import { createPerformanceRecord } from '@/api/createPerformanceRecord';
import Button from '@/components/Button/Button';
import { NotificationAtom } from '@/jotai/jotai';
import { formatDate } from '@/logics/date/date';
import { PerformanceRecordRequest } from '@/types/performanceRecord';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
  childID: number;
};

export const CreateDialog = ({ isOpen, setIsOpen, afterSubmit, childID }: Props) => {
  const [_, setNotification] = useAtom(NotificationAtom);

  const { handleSubmit } = useForm<PerformanceRecordRequest>({});

  const onSubmit: SubmitHandler<PerformanceRecordRequest> = async () => {
    try {
      // 前月分の実績記録を作成するため、前月の1日を設定
      const targetDate = new Date();
      targetDate.setMonth(targetDate.getMonth() - 1);
      targetDate.setDate(1);
      const result = await createPerformanceRecord(childID, {
        target_date: formatDate(targetDate),
      });
      console.log(result);
      if (result.status === 201) {
        console.log(result.result);
        setNotification({
          headingLevel: 'h2',
          type: 'success',
          bannerStyle: 'standard',
          title: '実績記録票を登録しました',
          message: '実績記録票を登録しました',
        });
      } else {
        setNotification({
          headingLevel: 'h2',
          type: 'error',
          bannerStyle: 'standard',
          title: '車両マスタの登録に失敗しました',
          message: '車両マスタの登録に失敗しました',
        });
      }
    } catch (error) {
      setNotification({
        headingLevel: 'h2',
        type: 'error',
        bannerStyle: 'standard',
        title: '車両マスタの登録に失敗しました',
        message: '車両マスタの登録に失敗しました',
      });
    }

    setIsOpen(false);
    afterSubmit();
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <div className="flex flex-row justify-between">
            <h1 className="mb-5 text-2xl font-700">実績記録票作成</h1>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row gap-4">
              <span>{`${new Date().getMonth()}月分の実績記録票を作成しますがよろしいですか？`}</span>
            </div>
            <div className="mt-10 flex flex-row items-center justify-center space-x-2">
              <Button
                type="button"
                size="lg"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                variant="solid-fill"
                size="lg"
                type="submit"
              >
                作成
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
